module.exports = __webpack_public_path__ + "img/PB_HalfStrap_Image_Einloesen_720x280_S.42fc3f57.png";